var map = {
	"./alertHexIcon.svg": 19514,
	"./back.svg": 34478,
	"./callAnAmbulanceIcon.svg": 72452,
	"./consultADoctorIcon.svg": 67204,
	"./copyIcon.svg": 98161,
	"./editIcon2.svg": 80085,
	"./editSettingsIcon.svg": 31381,
	"./femaleIconGeneric.svg": 84685,
	"./inProgressIcon.svg": 97813,
	"./kahunLogo.svg": 75848,
	"./kahunLogoNew.svg": 5297,
	"./landingPageDotsBackground.svg": 74119,
	"./maleIconGeneric.svg": 44206,
	"./patientCard/chartViewIcon.svg": 60155,
	"./patientCard/checkCircleIcon.svg": 8548,
	"./patientCard/kahunLogo.svg": 93153,
	"./patientCard/patient1stLogoWhite.svg": 13712,
	"./patientCard/summaryViewIcon.svg": 60214,
	"./patientCard/validatedIcon.svg": 3236,
	"./patientCard/viewOnAgentIcon.svg": 39208,
	"./patientCard/xCircleIcon.svg": 58267,
	"./ratingStar.svg": 14020,
	"./selfTreatmentIcon.svg": 93154,
	"./successIcon.svg": 45778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66682;